import { mapActions, mapState } from 'vuex'
import ImagenesView from '@/components/Layout/Menu/AdministradorFlotaNoProgramado/Visitas_cliente/Imagenes/ImagenesView.vue'
import EditarFieldView from '@/components/Layout/Menu/AdministradorFlotaNoProgramado/Editar_transporte/Editar_field/EditarFieldView.vue'
// import * as XLSX from 'xlsx/xlsx.mjs'
// import store from '@/store'
// import axios from 'axios'
// import router from '@/router/'
// import BarChart from '@/components/Layout/Menu/Graficos/BarChart/BarChart.vue'
// import store from '@/store'

export default {
  name: 'EditarTransporteView',
  components: {
    ImagenesView,
    EditarFieldView
  },
  props: {
    data: null
  },
  data: function () {
    return {
      dataJSON: [],
      transporte: 0,
      selectedConductor: null,
      optionsConductor: [
        { value: null, text: '- Conductor' }
      ],
      selectedCamion: null,
      optionsCamion: [
        { value: null, text: '- Camion' }
      ],
      selectedCliente: null,
      optionsCliente: [
        { value: null, text: '- Cliente' }
      ],
      selectedEstado: null,
      optionsEstado: [
        { value: null, text: '- Estado' },
        { value: 'entregada', text: 'entregada' },
        { value: 'no realizado', text: 'no realizado' }
      ],
      conductorId: null,
      camionId: null,
      transporte_id: null,
      editarModal: {
        id: 'editar-modal',
        title: 'Editar Campos',
        content: ''
      },
      fieldView: true,
      fecha: null,
      hora: null,
      fechaHora: null,
      selectedVuelta: null,
      optionsVuelta: [
        { value: null, text: '- Vueltas' }
      ],
      vuelta_cd: true
    }
  },
  watch: {
  },
  mounted () {
    this.dataJSON = JSON.parse(this.data)
    this.transporte = this.dataJSON.transporte
    this.transporte_id = this.dataJSON.id
    this.selectedEstado = this.dataJSON.estado
    this.vuelta_cd = !this.dataJSON.vuelta_cd
    this.getFechaHora(this.dataJSON.fecha)
    // console.log(this.vuelta_cd)
    // console.log(this.transporte_id)
    if (this.vuelta_cd) {
      this.optionsVuelta.push({ value: this.dataJSON.vuelta, text: this.dataJSON.vuelta })
      this.selectedVuelta = this.dataJSON.vuelta
      this.getVueltasCliente({ id_vuelta_principal: this.transporte_id }).then((res) => {
        // console.log(this.vueltasClientes)
        for (const v in this.vueltasClientes) {
          if (this.vueltasClientes[v].estado === 'entregada' || this.vueltasClientes[v].estado === 'no realizado') {
            this.optionsVuelta.push({ value: this.vueltasClientes[v].vuelta, text: this.vueltasClientes[v].vuelta })
          }
        }
      })
    }
    this.getConductores().then((res) => {
      for (const conductor in this.conductores) {
        if (this.conductores[conductor].device_alias === this.dataJSON.conductor) {
          this.selectedConductor = this.conductores[conductor].id
          this.conductorId = this.conductores[conductor].id
        }
        this.optionsConductor.push({ value: this.conductores[conductor].id, text: this.conductores[conductor].device_alias })
      }
      this.optionsConductor.sort((a, b) => a.text.localeCompare(b.text))
    })
    this.getCamiones().then((res) => {
      for (const camion in this.camiones) {
        if (this.camiones[camion].matricula + ' / ' + this.camiones[camion].cam_basis === this.dataJSON.cam_basis.matricula + ' / ' + this.dataJSON.cam_basis.cam_basis) {
          this.selectedCamion = this.camiones[camion].id
          this.camionId = this.camiones[camion].id
        }
        this.optionsCamion.push({ value: this.camiones[camion].id, text: this.camiones[camion].matricula + ' / ' + this.camiones[camion].cam_basis })
      }
      this.optionsCamion.sort((a, b) => a.text.localeCompare(b.text))
    })
    this.getClientes().then((res) => {
      // console.log(this.clientes)
      this.clientes.forEach(element => this.optionsCliente.push({
        value: element.nombre,
        text: element.nombre
      }))
      this.selectedCliente = this.dataJSON.cliente
    })
    this.EditarEnable()
  },
  methods: {
    ...mapActions('AdministradorFlota', [
      'getTransportes', 'getConductores', 'getAyudantes', 'getCamiones', 'getTransportesPage', 'getVueltasCliente', 'updateTransporte'
    ]),
    ...mapActions('Cliente', [
      'getClientes'
    ]),
    modalEditarsEnable (item, index, button) {
      // this.visitasModal.title = `Row index: ${index}`
      this.editarModal.id = 'editar-modal' + Date.now()
      const data = {
        transporte_id: this.transporte_id,
        transporte: this.transporte
      }
      this.editarModal.content = JSON.stringify(data)
      this.$root.$emit('bv::show::modal', this.editarModal.id, button)
    },
    EditarEnable (item, index, button) {
      // this.visitasModal.title = `Row index: ${index}`
      const data = {
        transporte_id: this.transporte_id,
        transporte: this.transporte
      }
      // console.log(data)
      this.editarModal.content = JSON.stringify(data)
    },
    hideModalEditar () {
      this.$refs[this.editarModal.id].hide()
    },
    emitEditarField (data) {
      console.log('emitEditarField')
      this.hideModalEditar()
    },
    editar () {
      const data = {}
      data.transporte_id = this.transporte_id
      if (this.selectedConductor !== this.conductorId) {
        // console.log('el conductor mo es el mismo')
        data.device_id = this.selectedConductor
      }
      if (this.transporte !== this.dataJSON.transporte) {
        // console.log('el transporte no es el mismo')
        data.transporte = parseInt(this.transporte)
      }
      if (this.selectedCamion !== this.camionId) {
        // console.log('el camion no es el mismo')
        data.camion_id = this.selectedCamion
      }
      if (this.selectedCliente !== this.dataJSON.cliente) {
        // console.log('el cliente no es el mismo')
        data.cliente = this.selectedCliente
      }
      if (this.selectedEstado !== this.dataJSON.estado) {
        // console.log('el cliente no es el mismo')
        data.estado = this.selectedEstado
      }
      const updateFecha = this.fecha + ' ' + this.hora
      if (this.fechaHora !== updateFecha) {
        // console.log('el cliente no es el mismo')
        data.fecha = updateFecha
      }
      this.updateTransporte(data).then((res) => {
        const toast = {}
        toast.title = 'Transporte Actualizado Con Exito.'
        toast.variant = 'success'
        toast.body = ''
        this.makeToast(toast)
        this.$emit('emitEditarTransporte', data)
      })
    },
    getFechaHora (data) {
      // data = '2023-10-14T03:06:35.000+00:00'
      // Crear un objeto Date a partir de la cadena
      const dateObj = new Date(data)
      // Obtener la fecha en el formato "yyyy-mm-dd"
      const year = dateObj.getFullYear()
      const month = String(dateObj.getMonth() + 1).padStart(2, '0') // Agregar ceros a la izquierda si es necesario
      const day = String(dateObj.getDate()).padStart(2, '0')
      const formattedDate = `${year}-${month}-${day}`
      // Obtener la hora en el formato "hh:mm:ss"
      const hours = String(dateObj.getUTCHours()).padStart(2, '0')
      const minutes = String(dateObj.getUTCMinutes()).padStart(2, '0')
      const seconds = String(dateObj.getUTCSeconds()).padStart(2, '0')
      const formattedTime = `${hours}:${minutes}:${seconds}`
      // console.log('Fecha:', formattedDate)
      // console.log('Hora:', formattedTime)
      this.fecha = formattedDate
      this.hora = formattedTime
      this.fechaHora = formattedDate + ' ' + formattedTime
    },
    cambiarVuelta () {
      console.log(this.selectedVuelta)
      var vueltaInicial = true
      for (const v in this.vueltasClientes) {
        if (this.vueltasClientes[v].vuelta === this.selectedVuelta) {
          console.log(this.vueltasClientes[v])
          this.transporte = this.vueltasClientes[v].transporte
          this.transporte_id = this.vueltasClientes[v].id
          this.selectedEstado = this.vueltasClientes[v].estado
          this.getFechaHora(this.vueltasClientes[v].fecha)
          this.selectedCliente = this.vueltasClientes[v].cliente
          for (const conductor in this.conductores) {
            if (this.conductores[conductor].device_alias === this.vueltasClientes[v].conductor) {
              this.selectedConductor = this.conductores[conductor].id
              this.conductorId = this.conductores[conductor].id
            }
          }
          for (const camion in this.camiones) {
            if (this.camiones[camion].matricula + ' / ' + this.camiones[camion].cam_basis === this.vueltasClientes[v].cam_basis.matricula + ' / ' + this.vueltasClientes[v].cam_basis.cam_basis) {
              this.selectedCamion = this.camiones[camion].id
              this.camionId = this.camiones[camion].id
            }
          }
          vueltaInicial = false
        }
      }
      if (vueltaInicial) {
        console.log(this.dataJSON)
        this.transporte = this.dataJSON.transporte
        this.transporte_id = this.dataJSON.id
        this.selectedEstado = this.dataJSON.estado
        this.vuelta_cd = !this.dataJSON.vuelta_cd
        this.getFechaHora(this.dataJSON.fecha)
        this.selectedCliente = this.dataJSON.cliente
        for (const conductor in this.conductores) {
          if (this.conductores[conductor].device_alias === this.dataJSON.conductor) {
            this.selectedConductor = this.conductores[conductor].id
            this.conductorId = this.conductores[conductor].id
          }
        }
        for (const camion in this.camiones) {
          if (this.camiones[camion].matricula + ' / ' + this.camiones[camion].cam_basis === this.dataJSON.cam_basis.matricula + ' / ' + this.dataJSON.cam_basis.cam_basis) {
            this.selectedCamion = this.camiones[camion].id
            this.camionId = this.camiones[camion].id
          }
        }
      }
      this.EditarEnable()
    },
    makeToast (toast) {
      this.$bvToast.toast(toast.body, {
        title: toast.title,
        variant: toast.variant,
        solid: true
      })
    }
  },
  computed: {
    ...mapState('AdministradorFlota', ['transportes']),
    ...mapState('AdministradorFlota', ['vueltasClientes']),
    ...mapState('AdministradorFlota', ['camiones']),
    ...mapState('AdministradorFlota', ['conductores']),
    ...mapState('Cliente', ['clientes'])
  }
}
